import { render, staticRenderFns } from "./StudentItem.vue?vue&type=template&id=381b995a"
import script from "./StudentItem.vue?vue&type=script&lang=ts"
export * from "./StudentItem.vue?vue&type=script&lang=ts"
import style0 from "./StudentItem.vue?vue&type=style&index=0&id=381b995a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports